import React, { useContext } from 'react';
import { Linking, Platform, StyleSheet, Text, View } from 'react-native';
import LayoutContext, { LAYOUTS } from '../../../contexts/Layout';

const getSubjectDomain = (domain = 'saCornerstone.org') => {
    if (domain.toLowerCase().includes('cornerstone')) {
        return 'SA%20Cornerstone';
    }
    if (domain.toLowerCase().includes('difference')) {
        return 'Difference%20Media';
    }
    return 'General%20Inquiry';
};

export const Location = ({ address, email, domain, isMobile, phoneNumber }) => {
    const { layout } = useContext(LayoutContext);
    const contactEmail = `mailto:${email}?subject=${getSubjectDomain(domain)}%20Website%20Connect`;

    return (
        <View
            style={StyleSheet.flatten(isMobile ? Styles.containerMobile : Styles.container, {
                marginHorizontal: layout.styleGuide.spacer1,
                marginVertical: 10
            })}
        >
            <Text
                onPress={() =>
                    Linking.openURL(
                        'https://www.google.com/maps/place/18755+Stone+Oak+Pkwy,+San+Antonio,+TX+78258/@29.6116366,-98.4972525,17z/data=!3m1!4b1!4m5!3m4!1s0x865c621d1e76216b:0x2c52b27ef477a5ad!8m2!3d29.6116366!4d-98.4950638'
                    )
                }
                style={Styles.address}
            >
                {isMobile ? address : address?.replace(', ', ',\n')}
            </Text>
            <View style={{ alignItems: isMobile ? undefined : 'flex-end', marginTop: isMobile ? layout.styleGuide.spacer1 : undefined }}>
                {!layout.mode === LAYOUTS.Modern && <Text>Contact Us</Text>}

                <Text numberOfLines={1} onPress={() => Linking.openURL(`tel:${phoneNumber?.replace(/\D/g, '')}`)} style={Styles.phoneNumber}>
                    {phoneNumber}
                </Text>
                <Text numberOfLines={1} onPress={async () => await Linking.openURL(contactEmail)} style={Styles.email}>
                    {email}
                </Text>
            </View>
        </View>
    );
};

const Styles = StyleSheet.create({
    address: {
        color: '#7f868b',
        fontSize: Platform.OS.equals('web') ? '14pt' : 14,
        justifyContent: 'flex-start'
    },
    container: {
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    containerMobile: {},
    email: {
        color: '#153d6e',
        fontFamily: 'GothamMedium',
        fontSize: Platform.OS.equals('web') ? '14pt' : 14
    },
    phoneNumber: {
        color: '#7f868b',
        fontSize: Platform.OS.equals('web') ? '14pt' : 14,
        justifyContent: 'flex-start'
    }
});
